<template>
    <el-form ref="searchForm" :model="searchData" inline>
        <el-form-item label="session">
            <el-input v-model="searchData.session" size="mini" style="width: 200px;" />
        </el-form-item>
        <el-form-item>
            <el-button size="mini" @click="handlerSearch" type="primary">提交</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import request from "@/api/request";

export default {
    data(){
        return {
            searchData: {
                session: ''
            }
        }
    },
    methods: {
        handlerSearch(){
            console.log(this.searchData)
            request.saas
                .post('tool/update_fengqi_spider_session', {
                    session: this.searchData.session
                })
                .then(() => {
                    this.$message.success('提交成功')
                })
        }
    }
}
</script>
